import { RetentionFlags } from './permissions.types';

const BASE_URL = process.env.REACT_APP_API_PAYMENT_METHODS ?? '';
const API_KEY = process.env.REACT_APP_XAPIKEY_TRANSACTION_AUTHORIZE ?? '';

interface PermissionsEnvelope {
    success?: boolean;
    errors?: { code?: number; message?: string; json_message?: unknown };
    data?: Partial<RetentionFlags>;
}

function headers(token: string): Record<string, string> {
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'x-api-key': API_KEY,
    };
}

/**
 * GET `commercial_panel/permissions` — devuelve los flags de sección
 * del operador logueado.
 */
export const getPermissionsApi = async (token: string): Promise<RetentionFlags> => {
    const url = `${BASE_URL}commercial_panel/permissions?country=MX`;
    const res = await fetch(url, { method: 'GET', headers: headers(token) });

    if (!res.ok) {
        const text = await res.text().catch(() => '');
        throw new Error(`HTTP ${res.status}: ${text}`);
    }

    const json = (await res.json()) as PermissionsEnvelope;
    if (json.success === false) {
        throw new Error(json.errors?.message || 'Error obteniendo permisos');
    }

    return {
        users_id: json.data?.users_id ?? 0,
        user_information: true,
        commercial_cart: true,
        vigencias: Boolean(json.data?.vigencias),
        asignaciones: Boolean(json.data?.asignaciones),
        slots_comerciales: Boolean(json.data?.slots_comerciales),
        panel_comerciales: Boolean(json.data?.panel_comerciales),
    };
};
